export const SET_SCHOOLS = 'setSchools'
